<template>
  <div class="login-box">
    <div class="login-logo">
      <a href>
        <b>ProCheck</b> CMS
      </a>
    </div>
    <el-dialog
      :visible.sync="cms_banner_visible"
      :before-close="closeBanner"
      :fullscreen="true"
      center>
      <el-container style="padding: none; !important">
        <el-image :src="banner_info.banner_img" :fit="'contain'"></el-image>
        <el-footer style="padding-top: 20px;text-align: center">
            <el-button @click="closeBanner()" type="primary" round>คลิกเพื่อเข้าสู่เว็บไซต์</el-button>
        </el-footer>
      </el-container>
    </el-dialog>
    <div class="login-box-body">
      <p class="login-box-msg"></p>
      <el-form @keydown.native.enter="sendForm">
        <el-form-item>
          <el-input v-model="username" :disabled="login_pending" placeholder="ชื่อผู้ใช้งาน"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="password" :disabled="login_pending" placeholder="รหัสผ่าน" type="password" show-password></el-input>
        </el-form-item>
        <div class="row">
          <div class="col-xs-12">
            <el-button type="primary" :disabled="login_pending" @click.prevent="sendForm" style="width: 100%">เข้าสู่ระบบ</el-button>
          </div>
          <div class="col-xs-6" align="center">
            <el-form-item>
              <el-checkbox v-model="remember">จดจำผู้ใช้งาน</el-checkbox>
            </el-form-item>
          </div>
          <div class="col-xs-6" align="center">
            <el-form-item>
              <router-link to="Forget_password">ลืมรหัสผ่าน</router-link>
            </el-form-item>
          </div>
          <div class="col-xs-12">
            <p>เมื่อคลิกเข้าสู่ระบบ แสดงว่าคุณยินยอมตาม <a class="consent-modal" @click.prevent="consent_dialog(privacy_policy)">ข้อกำหนด และนโยบายข้อมูลส่วนบุคคล </a> ,<a class="consent-modal" @click.prevent="consent_dialog(cookie_policy)">นโยบายคุกกี้</a>  และ<a class="consent-modal" @click.prevent="consent_dialog(security_policy)">นโยบายด้านความปลอดภัย</a></p>
          </div>
        </div>
      </el-form>
    </div>
    <modalConsent
      :info="info"
      :dialog="dialog"
      @checkModal="closeModal"
    ></modalConsent>
  </div>
</template>

<style>
.el-dialog__header {
  /* display: none */
}
.skin-blue.sidebar-mini {
  background-color: rgb(210, 214, 222);
}
.login-box-body.register-box-body {
  padding: 20px;
  color: #666;
  background: #fff;
  border-top: 0;
}
.checkbox.radio {
  position: relative;
  display: block;
  margin-top: 10px;
  margin-bottom: 10px;
}
.content-cookies2f {
    position: fixed;
    left: 0;
    bottom: 0;
    background-color: #f5f5f5;
    z-index: 2000;
    width: 100%;
    padding: 20px 0;
    box-shadow: 0 0 10px #ccc;
    -webkit-box-shadow: 0 0 10px #ccc;
    -moz-box-shadow: 0 0 10px #ccc;
    -o-box-shadow: 0 0 10px #ccc;
}
.box-cookies2f {
    position: relative;
    padding-right: 150px;
}
.content-cookies2f .btn-purple {
    width: auto;
    min-width: 120px;
    height: auto;
    /* padding: 5px 15px; */
    font-size: 14px;
    position: absolute;
    right: 0;
    top: 0;
}
.consent-modal {
  cursor: pointer;
}
.el-dialog__headerbtn .el-dialog__close {
    visibility: hidden;
}
</style>
<script>
import { mapState, mapActions } from 'vuex';
import modalConsent from './Modal/Modal_consent';
export default {
  components: {
    modalConsent
  },
  data(){
    return{
      username: this.$cookies.get('remember_procheck') ? this.$cookies.get('remember_procheck').username : '',
      password: '',
      remember: this.$cookies.get('remember_procheck') ? this.$cookies.get('remember_procheck').remember : '',
      dialog: false,
      terms_condition: {
        title: 'เงื่อนให้บริการ',
        content_th: '',
        content_en: ''
      },
      cookie_policy: {
        title: 'นโยบายคุกกี้',
        content_th: '',
        content_en: ''
      },
      privacy_policy: {
        title: 'ข้อกำหนด และนโยบายข้อมูลส่วนบุคคล',
        content_th: '',
        content_en: ''
      } ,
      security_policy: {
        title: 'นโยบายด้านความปลอดภัย',
        content_th: '',
        content_en: ''
      },
      info: '',
      block_banner : false,
      loging_in : false
    }
  },
  created() {
    this.$store.dispatch('Login_store/get_banner','cms')
    this.$store.dispatch('TermsAndConditionStore/getTermsAndCondition')
    this.$store.dispatch('PrivacyDataPolicyStore/getPrivacy')
    this.$store.dispatch('CookiePrivacyStore/getCookie')
    this.$store.dispatch('SecurityPolicyStore/getSecurity')
  },
  computed: {
    ...mapState({
      terms_condition_content_th : store => store.TermsAndConditionStore.content_th,
      terms_condition_content_en : store => store.TermsAndConditionStore.content_en,
      cookie_policy_content_th : store => store.CookiePrivacyStore.content_th,
      cookie_policy_content_en : store => store.CookiePrivacyStore.content_en,
      privacy_policy_content_th : store => store.PrivacyDataPolicyStore.content_th,
      privacy_policy_content_en : store => store.PrivacyDataPolicyStore.content_en,
      security_policy_content_th : store => store.SecurityPolicyStore.content_th,
      banner_info : store => store.Login_store.banner_info,
      cms_banner_visible : store => store.Login_store.cms_banner_visible,
      login_pending : store => store.Login_store.login_pending
    })
  },
  mounted() {
    this.terms_condition.content_th = this.terms_condition_content_th
    this.terms_condition.content_en = this.terms_condition_content_en
    this.cookie_policy.content_th = this.cookie_policy_content_th
    this.privacy_policy.content_th = this.privacy_policy_content_th
    this.security_policy.content_th = this.security_policy_content_th
  },
  watch: {
    terms_condition_content_th : {
      handler : function(reload) {
        this.terms_condition.content_th = reload
      }
    },
    terms_condition_content_en : {
      handler : function(reload) {
        this.terms_condition.content_en = reload
      }
    },
    cookie_policy_content_th : {
      handler : function(reload) {
        this.cookie_policy.content_th = reload
      }
    },
    cookie_policy_content_en : {
      handler : function(reload) {
        this.cookie_policy.content_en = reload
      }
    },
    privacy_policy_content_th : {
      handler : function(reload) {
        this.privacy_policy.content_th = reload
      }
    },
    privacy_policy_content_en : {
      handler : function(reload) {
        this.privacy_policy.content_en = reload
      }
    },
    security_policy_content_th : {
      handler : function(reload) {
        this.security_policy.content_th = reload
      }
    }
  },
  methods:{
    ...mapActions({
      login:'Login_store/login',
      disable_banner: 'Login_store/disable_banner'
    }),
    sendForm(){
      if(this.username === ""){
             this.$confirm('กรุณากรอกชื่อผู้ใช้งาน', 'แจ้งเตือน', {
          confirmButtonText: 'ตกลง',
          cancelButtonText: 'ยกเลิก',
          showCancelButton: false,
          type: 'warning'
        }).then(() => { }).catch(() => {  });
      } else if(this.password === ""){
         this.$confirm('กรุณากรอกรหัสผ่าน', 'แจ้งเตือน', {
          confirmButtonText: 'ตกลง',
          cancelButtonText: 'ยกเลิก',
          showCancelButton: false,
          type: 'warning'
        }).then(() => { }).catch(() => {  });
      }else{
        this.login({
        username : this.username,
        password : this.password,
        remember : this.remember
        })
      }
    },
    consent_dialog(data){
      console.log(data)
      this.info = data
      this.dialog = true
    },
    closeModal(value) {
      this.dialog = value;
      this.requestDialog = value
    },
    closeBanner(){
      this.disable_banner(true)
    }
  }
}
</script>



